import { useEffect } from 'react';
import { useAuth } from '../../components/features/auth/AuthGuard';
import ObjectiveList from '../../components/features/performance/ObjectiveList';
import { PERMISSIONS } from '../../constants';
import { Box, Alert } from '@mui/material';

const PendingApprovalsPage = () => {
  const { hasPermission } = useAuth();

  // Check if user has permission to view pending approvals
  if (!hasPermission(PERMISSIONS.PERFORMANCE_APPROVE)) {
    return (
      <Box p={3}>
        <Alert severity="error">
          You don't have permission to view pending approvals.
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <ObjectiveList 
        type="pending"
        title="Objectives Pending Approval"
      />
    </Box>
  );
};

export default PendingApprovalsPage;
